import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BackTop',
  props: {
    bottom: {}
  },
  setup(__props: any) {


const isShow = ref(false)
onMounted(() => {
  // 控制按钮显示隐藏
  window.addEventListener('scroll', () => {
    if (window.scrollY > window.innerHeight) {
      isShow.value = true
    } else {
      isShow.value = false
    }
  })
})
const backTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "back-top",
    onClick: backTop,
    style: _normalizeStyle('bottom:' + (_ctx.bottom || '200px'))
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("i", { class: "iconfont icon-icon_shequzhongxin_zhiding" }, null, -1)
  ]), 4)), [
    [_vShow, isShow.value]
  ])
}
}

})